import { cn } from '@/src/infrastructure/lib/utils';

type ProductStatus = 'ACTIVE' | 'INACTIVE';

const COLORS: Record<ProductStatus, string> = {
  ACTIVE: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
  INACTIVE: 'bg-amber-500/15 text-amber-300 border-amber-500/30',
};

/** Two states only — `isActive` toggle, matching backend §6.6 Option A. No DRAFT/ARCHIVED. */
export function ProductStatusBadge({ isActive }: { isActive: boolean }) {
  const status: ProductStatus = isActive ? 'ACTIVE' : 'INACTIVE';
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded-full border text-[10px] uppercase font-bold tracking-widest',
        COLORS[status],
      )}
    >
      {status}
    </span>
  );
}
